import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

/**
 * Modulo que agrupa todos los pipes comunes de la página, los individuales de cada sección se meterán dentro de la propia seccion
 */
@NgModule({
  imports: [
    CommonModule,
  ],
  providers: [],
  declarations: [],
  exports: [],
})
export class PipesModule { }
